import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const toolsLineLeft = svgToTinyDataUri(
  `<svg preserveAspectRatio="none" width="100%" height="100%" overflow="visible" style="display: block;" viewBox="0 0 96 2" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Vector 445">
<path d="M0 1H96" stroke="var(--stroke-0, #501283)" stroke-width="2"/>
<path d="M0 1H96" stroke="var(--stroke-1, #501283)" stroke-width="2"/>
</g>
</svg>`
);
